import { render, staticRenderFns } from "./TrailerOrder_Component.vue?vue&type=template&id=4faca450&scoped=true&"
import script from "./TrailerOrder_Component.vue?vue&type=script&lang=js&"
export * from "./TrailerOrder_Component.vue?vue&type=script&lang=js&"
import style0 from "./TrailerOrder_Component.vue?vue&type=style&index=0&id=4faca450&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4faca450",
  null
  
)

export default component.exports